import { Page } from '@/components/layout/page/page'
import { usePaginationState } from '@/components/ui/table/hooks/usePaginationState'
import { useSearchQuery } from '@/components/ui/table/hooks/useSearchQuery'
import { SharedFollowersHeaderButtons } from '@/modules/creator-settings/lists/shared-followers/components/SharedFollowersHeaderButtons'
import { SharedFollowersListTable } from '@/modules/creator-settings/lists/shared-followers/components/SharedFollowersListTable'
import { useGetSharedFollowerList } from '@/modules/creator-settings/lists/shared-followers/hooks/useGetSharedFollowerList'

export const SharedFollowersView = () => {
  const { paginationState, setPaginationState } = usePaginationState({
    pageIndex: 0,
    pageSize: 10,
  })
  const { searchQuery, setSearchQuery } = useSearchQuery('')

  const { refetch, data, isFetching } = useGetSharedFollowerList({
    page: paginationState.pageIndex,
    size: paginationState.pageSize,
    fanName: searchQuery,
  })

  return (
    <Page
      title="Shared Following List"
      description="See the list of fans who follow at least two or more of your creators on your account"
      headerOptions={
        <SharedFollowersHeaderButtons
          onRefreshPress={refetch}
          setFilter={setSearchQuery}
        />
      }
    >
      <SharedFollowersListTable
        paginationState={paginationState}
        onPaginationChange={setPaginationState}
        list={data?.content ?? []}
        isFetching={isFetching}
        pageCount={data?.totalPages ?? 0}
      />
    </Page>
  )
}
